










import Vue from 'vue'
import Nav from '@/components/Nav.vue'

export default Vue.extend({
  components: { Nav },
  data() {
    return { html: '', loading: true, error: '' }
  },
  // 2026-11-04 Claude : Affiche le HTML redige manuellement, sans analyse PHP ni recalcul de catalogue.
  async mounted() {
    try {
      const response = await fetch(`${process.env.BASE_URL}documentation/balises-modeles.html`, {
        cache: 'no-cache',
      })
      if (!response.ok) throw new Error('Documentation indisponible.')
      const content = await response.text()
      if (!content.includes('id="balises-modeles"')) throw new Error('Documentation indisponible.')
      this.html = content
    } catch (error) {
      this.error = 'Impossible de charger la documentation des balises. Veuillez réessayer ultérieurement.'
    } finally {
      this.loading = false
    }
  },
})
